define('SEOImprovements.HeaderLogo.View', [
    'Header.Logo.View',
    'underscore',
    'Configuration'
], function SEOImprovementsHeaderLogoView(
    HeaderLogoView,
    _,
    Configuration
) {
    'use strict';

    Configuration = Configuration.Configuration || Configuration;

    _.extend(HeaderLogoView.prototype, {
        getContext: _.wrap(HeaderLogoView.prototype.getContext, function onGetContext(fn) {
            var originalRet = fn.apply(this, _.toArray(arguments).slice(1));
            originalRet.siteName = originalRet.siteName || Configuration.get('siteTitle');
            return originalRet;
        })
    });
});
